{
  "en": {
    "home": "Welcome",
    "colorBook": "Eagle Color Book",
    "storyBook": "Read Stories",
    "welcomeMessage": "The stories you find on this website have been told by Rev. William Branham. They have been retold for children and each one contains a message that can help you in your Christian dedicated walk with God. Our prayer is that the children may hear these stories and identify themselves with the work of the Lord, for them to catch faith in God. It’s our desire that their trust in Him grows for the leadership of the Holy Spirit in their lives in order to live a sanctified, humble and victorious life, filled with His Spirit.\n\n Ye are of God, little children, and have overcome them: because greater is he that is in you, than he that is in the world. (1. John 4:4)\n\n God bless you as you read these stories to the little children of God. And remember, Jesus loves the little children.\n Shalom!",
    "previous": "Previous",
    "next": "Next",
    "readIt": "Read it",
    "download": "Download",
    "story_coming_soon": "Story Coming Soon!",
    "beta_release_message": "This website is currently in Beta. Expect changes and improvements.",
    "order_message": "Would you like to receive printed versions of these stories?",
    "order_button": "Get Printed Stories",
    "undo": "Undo",
    "reset": "Start over",
    "of": "of",
    "color_palette": "Colours",
    "illustration_alt": "Picture from the story",
    "coloring_page_alt": "Colouring picture",
    "no_text_for_language": "No text in this language yet.",
    "story_unavailable": "Not in this language yet",
    "open_menu": "Open menu",
    "close_menu": "Close menu",
    "choose_language": "Choose language",
    "home_link": "Home",
    "loading_story": "Loading the story…",
    "page_not_found": "That page does not exist.",
    "back_home": "Back to the start",
    "skip_to_content": "Skip to content",
    "color_white": "white",
    "color_beige": "beige",
    "color_peach": "peach",
    "color_pink": "pink",
    "color_yellow": "yellow",
    "color_red": "red",
    "color_orange": "orange",
    "color_dark_red": "dark red",
    "color_cream": "cream",
    "color_light_blue": "light blue",
    "color_lime": "lime green",
    "color_lavender": "lavender",
    "color_sage": "sage green",
    "color_blue_grey": "blue grey",
    "color_green": "green",
    "color_navy": "navy blue",
    "color_purple": "purple",
    "color_gold": "gold",
    "color_sky_blue": "sky blue",
    "color_light_brown": "light brown",
    "color_blue": "blue",
    "color_sand": "sand",
    "color_dark_blue": "dark blue",
    "color_taupe": "grey brown",
    "color_light_grey": "light grey",
    "color_caramel": "caramel",
    "color_grey": "grey",
    "color_stone": "stone grey",
    "color_dark_grey": "dark grey",
    "color_brown": "brown",
    "color_dark_brown": "dark brown",
    "color_black": "black",
    "color_burgundy": "burgundy",
    "color_salmon": "salmon",
    "color_mint": "mint green",
    "color_indigo": "indigo",
    "color_dark_teal": "dark teal",
    "color_turquoise": "turquoise",
    "error_title": "Something went wrong",
    "error_body": "Sorry — this page could not be shown. Going back to the start usually fixes it.",
    "page_of": "Page",
    "home_colorbook_blurb": "Colour the pictures in whatever colours you like.",
    "home_storybook_blurb": "Read a story on screen, or print it out.",
    "home_about": "About these stories"
  },
  "de": {
    "home": "Willkommen",
    "colorBook": "Adler Malbuch",
    "storyBook": "Geschichten",
    "welcomeMessage": "Die Geschichten, die Sie auf dieser Website finden, wurden von Rev. William Branham erzählt. Sie wurden für Kinder nacherzählt, und jede enthält eine Botschaft, die Ihnen auf Ihrem christlichen Weg mit Gott helfen kann. Unser Gebet ist, dass die Kinder diese Geschichten hören und sich mit dem Werk des Herrn identifizieren, damit sie Glauben an Gott fassen.\n\nEs ist unser Wunsch, dass ihr Vertrauen in Ihn wächst, damit sie unter der Führung des Heiligen Geistes ein geheiligtes, demütiges und siegreiches Leben führen, erfüllt mit Seinem Geist.\n\n Ihr seid aus Gott, Kindlein, und habt sie überwunden; denn der, der in euch ist, ist größer als der, der in der Welt ist. (1. Johannes 4:4)\n\n Gott segne euch, wenn ihr diese Geschichten den kleinen Kindern Gottes vorlest. Und denkt daran: Jesus liebt die kleinen Kinder.\n Shalom!",
    "previous": "Zurück",
    "next": "Nächste",
    "readIt": "Lesen",
    "download": "Herunterladen",
    "story_coming_soon": "Die Geschichte kommt bald!",
    "beta_release_message": "Diese Website befindet sich in der Beta-Phase. Es werden noch Änderungen und Verbesserungen vorgenommen.",
    "order_message": "Möchtest du gedruckte Versionen dieser Geschichten erhalten?",
    "order_button": "Gedruckte Geschichten erhalten",
    "undo": "Rückgängig",
    "reset": "Neu beginnen",
    "of": "von",
    "color_palette": "Farben",
    "illustration_alt": "Bild aus der Geschichte",
    "coloring_page_alt": "Ausmalbild",
    "no_text_for_language": "Noch kein Text in dieser Sprache.",
    "story_unavailable": "Noch nicht in dieser Sprache",
    "open_menu": "Menü öffnen",
    "close_menu": "Menü schließen",
    "choose_language": "Sprache wählen",
    "home_link": "Startseite",
    "loading_story": "Die Geschichte lädt…",
    "page_not_found": "Diese Seite gibt es nicht.",
    "back_home": "Zurück zum Anfang",
    "skip_to_content": "Zum Inhalt springen",
    "color_white": "Weiß",
    "color_beige": "Beige",
    "color_peach": "Pfirsich",
    "color_pink": "Rosa",
    "color_yellow": "Gelb",
    "color_red": "Rot",
    "color_orange": "Orange",
    "color_dark_red": "Dunkelrot",
    "color_cream": "Creme",
    "color_light_blue": "Hellblau",
    "color_lime": "Limettengrün",
    "color_lavender": "Lavendel",
    "color_sage": "Salbeigrün",
    "color_blue_grey": "Blaugrau",
    "color_green": "Grün",
    "color_navy": "Marineblau",
    "color_purple": "Lila",
    "color_gold": "Gold",
    "color_sky_blue": "Himmelblau",
    "color_light_brown": "Hellbraun",
    "color_blue": "Blau",
    "color_sand": "Sand",
    "color_dark_blue": "Dunkelblau",
    "color_taupe": "Graubraun",
    "color_light_grey": "Hellgrau",
    "color_caramel": "Karamell",
    "color_grey": "Grau",
    "color_stone": "Steingrau",
    "color_dark_grey": "Dunkelgrau",
    "color_brown": "Braun",
    "color_dark_brown": "Dunkelbraun",
    "color_black": "Schwarz",
    "color_burgundy": "Bordeaux",
    "color_salmon": "Lachsrosa",
    "color_mint": "Mintgrün",
    "color_indigo": "Indigo",
    "color_dark_teal": "Dunkles Petrol",
    "color_turquoise": "Türkis",
    "error_title": "Etwas ist schiefgelaufen",
    "error_body": "Entschuldigung — diese Seite konnte nicht angezeigt werden. Zurück zum Anfang hilft meistens.",
    "page_of": "Seite",
    "home_colorbook_blurb": "Male die Bilder in den Farben aus, die dir gefallen.",
    "home_storybook_blurb": "Lies eine Geschichte am Bildschirm oder drucke sie aus.",
    "home_about": "Über diese Geschichten"
  },
  "fr": {
    "home": "Bienvenue",
    "colorBook": "Livre à colorier",
    "storyBook": "Livre d'histoires",
    "welcomeMessage": "Les histoires que vous trouvez sur ce site ont été racontées par le Rév. William Branham. Elles ont été adaptées pour les enfants, et chacune contient un message qui peut vous aider dans votre marche chrétienne avec Dieu. Notre prière est que les enfants entendent ces histoires et s’identifient à l’œuvre du Seigneur, afin qu’ils aient foi en Dieu.\n\nNous désirons qu’ils placent leur confiance en Lui, grandissant sous la direction du Saint-Esprit, pour vivre une vie sanctifiée, humble et victorieuse, remplie de Son Esprit.\n\n Vous, petits enfants, vous êtes de Dieu, et vous les avez vaincus; car celui qui est en vous est plus grand que celui qui est dans le monde. (1 Jean 4:4)\n\n Que Dieu vous bénisse en lisant ces histoires aux petits enfants de Dieu. Et souvenez-vous, Jésus aime les petits enfants.\n Shalom!",
    "previous": "Précédent",
    "next": "Suivant",
    "readIt": "Lire",
    "download": "Télécharger",
    "story_coming_soon": "Histoire à venir!",
    "beta_release_message": "Ce site est actuellement en version bêta. Attendez-vous à des changements et des améliorations.",
    "order_message": "Souhaitez-vous recevoir les versions imprimées de ces histoires?",
    "order_button": "Commander les histoires imprimées",
    "undo": "Annuler",
    "reset": "Recommencer",
    "of": "sur",
    "color_palette": "Couleurs",
    "illustration_alt": "Image de l'histoire",
    "coloring_page_alt": "Image à colorier",
    "no_text_for_language": "Pas encore de texte dans cette langue.",
    "story_unavailable": "Pas encore dans cette langue",
    "open_menu": "Ouvrir le menu",
    "close_menu": "Fermer le menu",
    "choose_language": "Choisir la langue",
    "home_link": "Accueil",
    "loading_story": "Chargement de l'histoire…",
    "page_not_found": "Cette page n'existe pas.",
    "back_home": "Retour au début",
    "skip_to_content": "Aller au contenu",
    "color_white": "blanc",
    "color_beige": "beige",
    "color_peach": "pêche",
    "color_pink": "rose",
    "color_yellow": "jaune",
    "color_red": "rouge",
    "color_orange": "orange",
    "color_dark_red": "rouge foncé",
    "color_cream": "crème",
    "color_light_blue": "bleu clair",
    "color_lime": "vert citron",
    "color_lavender": "lavande",
    "color_sage": "vert sauge",
    "color_blue_grey": "gris bleu",
    "color_green": "vert",
    "color_navy": "bleu marine",
    "color_purple": "violet",
    "color_gold": "or",
    "color_sky_blue": "bleu ciel",
    "color_light_brown": "brun clair",
    "color_blue": "bleu",
    "color_sand": "sable",
    "color_dark_blue": "bleu foncé",
    "color_taupe": "gris brun",
    "color_light_grey": "gris clair",
    "color_caramel": "caramel",
    "color_grey": "gris",
    "color_stone": "gris pierre",
    "color_dark_grey": "gris foncé",
    "color_brown": "brun",
    "color_dark_brown": "brun foncé",
    "color_black": "noir",
    "color_burgundy": "bordeaux",
    "color_salmon": "saumon",
    "color_mint": "vert menthe",
    "color_indigo": "indigo",
    "color_dark_teal": "bleu pétrole foncé",
    "color_turquoise": "turquoise",
    "error_title": "Une erreur est survenue",
    "error_body": "Désolé — cette page n'a pas pu s'afficher. Revenir au début règle le problème la plupart du temps.",
    "page_of": "Page",
    "home_colorbook_blurb": "Colorie les images avec les couleurs que tu veux.",
    "home_storybook_blurb": "Lis une histoire à l'écran, ou imprime-la.",
    "home_about": "À propos de ces histoires"
  },
  "pl": {
    "home": "Witamy",
    "colorBook": "Książka do kolorowania",
    "storyBook": "Książka z opowiadaniami",
    "welcomeMessage": "Historie, które znajdziesz na tej stronie, zostały opowiedziane przez pastora Williama Branhama. Zostały dostosowane dla dzieci, a każda z nich zawiera przesłanie, które może pomóc Ci w Twojej chrześcijańskiej wędrówce z Bogiem. Naszą modlitwą jest, aby dzieci usłyszały te historie i utożsamiały się z dziełem Pana, aby mogły uwierzyć w Boga.\n\nChcemy, aby ich zaufanie do Niego rosło pod przewodnictwem Ducha Świętego, aby mogły prowadzić uświęcone, pokorne i zwycięskie życie, pełne Jego Ducha.\n\n Wy, dzieci, jesteście z Boga i zwyciężyliście ich, ponieważ Ten, który jest w was, jest większy niż ten, który jest na świecie. (1 Jana 4:4)\n\n Niech Bóg błogosławi was, gdy czytacie te historie małym dzieciom Bożym. I pamiętajcie, Jezus kocha małe dzieci.\n Shalom!",
    "previous": "Poprzedni",
    "next": "Następny",
    "readIt": "Czytaj",
    "download": "Pobierz",
    "story_coming_soon": "Historia już wkrótce!",
    "beta_release_message": "Ta strona jest obecnie w fazie Beta. Oczekuj zmian i ulepszeń.",
    "order_message": "Czy chciałbyś otrzymać drukowane wersje tych opowiadań?",
    "order_button": "Otrzymaj drukowane opowiadania",
    "undo": "Cofnij",
    "reset": "Zacznij od nowa",
    "of": "z",
    "color_palette": "Kolory",
    "illustration_alt": "Obrazek z opowiadania",
    "coloring_page_alt": "Obrazek do kolorowania",
    "no_text_for_language": "Jeszcze nie ma tekstu w tym języku.",
    "story_unavailable": "Jeszcze nie w tym języku",
    "open_menu": "Otwórz menu",
    "close_menu": "Zamknij menu",
    "choose_language": "Wybierz język",
    "home_link": "Strona główna",
    "loading_story": "Wczytywanie opowiadania…",
    "page_not_found": "Taka strona nie istnieje.",
    "back_home": "Wróć na początek",
    "skip_to_content": "Przejdź do treści",
    "color_white": "biały",
    "color_beige": "beżowy",
    "color_peach": "brzoskwiniowy",
    "color_pink": "różowy",
    "color_yellow": "żółty",
    "color_red": "czerwony",
    "color_orange": "pomarańczowy",
    "color_dark_red": "ciemnoczerwony",
    "color_cream": "kremowy",
    "color_light_blue": "jasnoniebieski",
    "color_lime": "limonkowy",
    "color_lavender": "lawendowy",
    "color_sage": "szałwiowy",
    "color_blue_grey": "niebieskoszary",
    "color_green": "zielony",
    "color_navy": "granatowy",
    "color_purple": "fioletowy",
    "color_gold": "złoty",
    "color_sky_blue": "błękitny",
    "color_light_brown": "jasnobrązowy",
    "color_blue": "niebieski",
    "color_sand": "piaskowy",
    "color_dark_blue": "ciemnoniebieski",
    "color_taupe": "szarobrązowy",
    "color_light_grey": "jasnoszary",
    "color_caramel": "karmelowy",
    "color_grey": "szary",
    "color_stone": "kamienny",
    "color_dark_grey": "ciemnoszary",
    "color_brown": "brązowy",
    "color_dark_brown": "ciemnobrązowy",
    "color_black": "czarny",
    "color_burgundy": "bordowy",
    "color_salmon": "łososiowy",
    "color_mint": "miętowy",
    "color_indigo": "indygo",
    "color_dark_teal": "ciemny morski",
    "color_turquoise": "turkusowy",
    "error_title": "Coś poszło nie tak",
    "error_body": "Przepraszamy — nie udało się wyświetlić tej strony. Powrót na początek zwykle pomaga.",
    "page_of": "Strona",
    "home_colorbook_blurb": "Pokoloruj obrazki tak, jak chcesz.",
    "home_storybook_blurb": "Przeczytaj opowiadanie na ekranie albo je wydrukuj.",
    "home_about": "O tych opowiadaniach"
  },
  "it": {
    "home": "Benvenuto",
    "colorBook": "Libro dei Colori dell'Aquila",
    "storyBook": "Storie",
    "welcomeMessage": "Le storie che trovi su questo sito web sono state raccontate dal Rev. William Branham. Sono state adattate per i bambini e ognuna contiene un messaggio che può aiutarti nel tuo cammino cristiano con Dio. La nostra preghiera è che i bambini possano ascoltare queste storie e identificarsi con l'opera del Signore, affinché possano avere fede in Dio.\n\nDesideriamo che la loro fiducia in Lui cresca sotto la guida dello Spirito Santo, affinché possano vivere una vita santificata, umile e vittoriosa, colma del Suo Spirito.\n\n Voi siete da Dio, figlioletti, e li avete vinti; perché Colui che è in voi è più grande di colui che è nel mondo. (1 Giovanni 4:4)\n\n Dio vi benedica mentre leggete queste storie ai piccoli figli di Dio. E ricordate, Gesù ama i bambini.\n Shalom!",
    "previous": "Precedente",
    "next": "Prossimo",
    "readIt": "Leggilo",
    "download": "Scarica",
    "story_coming_soon": "Storia in arrivo!",
    "beta_release_message": "Questo sito è attualmente in Beta. Aspettatevi cambiamenti e miglioramenti.",
    "order_message": "Ti piacerebbe ricevere le versioni stampate di queste storie?",
    "order_button": "Ricevi le storie stampate",
    "undo": "Annulla",
    "reset": "Ricomincia",
    "of": "di",
    "color_palette": "Colori",
    "illustration_alt": "Immagine della storia",
    "coloring_page_alt": "Disegno da colorare",
    "no_text_for_language": "Non c’è ancora testo in questa lingua.",
    "story_unavailable": "Non ancora in questa lingua",
    "open_menu": "Apri il menu",
    "close_menu": "Chiudi il menu",
    "choose_language": "Scegli la lingua",
    "home_link": "Home",
    "loading_story": "Caricamento della storia…",
    "page_not_found": "Questa pagina non esiste.",
    "back_home": "Torna all’inizio",
    "skip_to_content": "Vai al contenuto",
    "color_white": "bianco",
    "color_beige": "beige",
    "color_peach": "pesca",
    "color_pink": "rosa",
    "color_yellow": "giallo",
    "color_red": "rosso",
    "color_orange": "arancione",
    "color_dark_red": "rosso scuro",
    "color_cream": "crema",
    "color_light_blue": "azzurro",
    "color_lime": "verde lime",
    "color_lavender": "lavanda",
    "color_sage": "verde salvia",
    "color_blue_grey": "grigio blu",
    "color_green": "verde",
    "color_navy": "blu navy",
    "color_purple": "viola",
    "color_gold": "oro",
    "color_sky_blue": "azzurro cielo",
    "color_light_brown": "marrone chiaro",
    "color_blue": "blu",
    "color_sand": "sabbia",
    "color_dark_blue": "blu scuro",
    "color_taupe": "grigio marrone",
    "color_light_grey": "grigio chiaro",
    "color_caramel": "caramello",
    "color_grey": "grigio",
    "color_stone": "grigio pietra",
    "color_dark_grey": "grigio scuro",
    "color_brown": "marrone",
    "color_dark_brown": "marrone scuro",
    "color_black": "nero",
    "color_burgundy": "bordeaux",
    "color_salmon": "salmone",
    "color_mint": "verde menta",
    "color_indigo": "indaco",
    "color_dark_teal": "petrolio scuro",
    "color_turquoise": "turchese",
    "error_title": "Qualcosa è andato storto",
    "error_body": "Spiacenti — non è stato possibile mostrare questa pagina. Tornare all'inizio di solito risolve.",
    "page_of": "Pagina",
    "home_colorbook_blurb": "Colora i disegni con i colori che preferisci.",
    "home_storybook_blurb": "Leggi una storia sullo schermo, oppure stampala.",
    "home_about": "Su queste storie"
  },
  "ro": {
    "home": "Bun venit",
    "colorBook": "Cartea de culori vultur",
    "storyBook": "Povești",
    "welcomeMessage": "Poveștile pe care le găsiți pe acest site au fost spuse de Rev. William Branham. Acestea au fost adaptate pentru copii, iar fiecare conține un mesaj care vă poate ajuta în umblarea voastră creștină cu Dumnezeu. Rugăciunea noastră este ca copiii să audă aceste povești și să se identifice cu lucrarea Domnului, pentru a avea credință în Dumnezeu.\n\nNe dorim ca încrederea lor în El să crească sub călăuzirea Duhului Sfânt, astfel încât să ducă o viață sfințită, smerită și victorioasă, plină de Duhul Său.\n\n Voi, copilașilor, sunteți din Dumnezeu și i-ați biruit; pentru că Cel ce este în voi este mai mare decât cel ce este în lume. (1 Ioan 4:4)\n\n Dumnezeu să vă binecuvânteze în timp ce citiți aceste povești micilor copii ai lui Dumnezeu. Și nu uitați, Isus iubește copiii.\n Shalom!",
    "previous": "Precedent",
    "next": "Următorul",
    "readIt": "Citiți-l",
    "download": "Descărcați",
    "story_coming_soon": "Povestea în curând!",
    "beta_release_message": "Acest site este în prezent în Beta. Așteptați-vă la modificări și îmbunătățiri.",
    "order_message": "Ai dori să primești versiunile tipărite ale acestor povești?",
    "order_button": "Primește poveștile tipărite",
    "undo": "Anulează",
    "reset": "Începe din nou",
    "of": "din",
    "color_palette": "Culori",
    "illustration_alt": "Imagine din poveste",
    "coloring_page_alt": "Imagine de colorat",
    "no_text_for_language": "Încă nu există text în această limbă.",
    "story_unavailable": "Încă nu în această limbă",
    "open_menu": "Deschide meniul",
    "close_menu": "Închide meniul",
    "choose_language": "Alege limba",
    "home_link": "Acasă",
    "loading_story": "Se încarcă povestea…",
    "page_not_found": "Această pagină nu există.",
    "back_home": "Înapoi la început",
    "skip_to_content": "Sari la conținut",
    "color_white": "alb",
    "color_beige": "bej",
    "color_peach": "piersică",
    "color_pink": "roz",
    "color_yellow": "galben",
    "color_red": "roșu",
    "color_orange": "portocaliu",
    "color_dark_red": "roșu închis",
    "color_cream": "crem",
    "color_light_blue": "albastru deschis",
    "color_lime": "verde lime",
    "color_lavender": "lavandă",
    "color_sage": "verde salvie",
    "color_blue_grey": "gri albăstrui",
    "color_green": "verde",
    "color_navy": "bleumarin",
    "color_purple": "mov",
    "color_gold": "auriu",
    "color_sky_blue": "azuriu",
    "color_light_brown": "maro deschis",
    "color_blue": "albastru",
    "color_sand": "nisipiu",
    "color_dark_blue": "albastru închis",
    "color_taupe": "gri maroniu",
    "color_light_grey": "gri deschis",
    "color_caramel": "caramel",
    "color_grey": "gri",
    "color_stone": "gri piatră",
    "color_dark_grey": "gri închis",
    "color_brown": "maro",
    "color_dark_brown": "maro închis",
    "color_black": "negru",
    "color_burgundy": "bordo",
    "color_salmon": "somon",
    "color_mint": "verde mentă",
    "color_indigo": "indigo",
    "color_dark_teal": "petrol închis",
    "color_turquoise": "turcoaz",
    "error_title": "Ceva nu a mers bine",
    "error_body": "Ne pare rău — această pagină nu a putut fi afișată. Întoarcerea la început rezolvă de obicei problema.",
    "page_of": "Pagina",
    "home_colorbook_blurb": "Colorează imaginile cu ce culori vrei tu.",
    "home_storybook_blurb": "Citește o poveste pe ecran sau tipărește-o.",
    "home_about": "Despre aceste povești"
  }
}